
import { Vue, Component } from 'vue-property-decorator'
import Subelement from '@/types/subelement'
import SubelementEditDetailsTab from '@/views/subelement/tabs/edit/SubelementEditDetailsTab.vue'
import SubelementEditElementsTab from '@/views/subelement/tabs/edit/SubelementEditElementsTab.vue'
import SubelementEditOptionsTab from '@/views/subelement/tabs/edit/SubelementEditOptionsTab.vue'
import ls from '@/ls'

@Component({
  components: { SubelementEditOptionsTab, SubelementEditElementsTab, SubelementEditDetailsTab }
})

export default class SubelementCreate extends Vue {
  settings = {
    routeNames: { list: 'subelements', show: 'subelementShow', edit: 'subelementEdit' },
    routeParamKey: 'subelementId',
    functionNames: { setCurrent: 'setCurrentSubelement', clearCurrent: 'clearCurrentSubelement', save: 'saveSubelement' },
    getterNames: { current: 'currentSubelement', loading: 'loadingSubelement' }
  }

  currentTab:string = ls.get('subelementEditActiveTab') || 'details'

  mounted () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('subelementEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, paramKey:string|undefined, id:number|undefined) : void {
    if (id && paramKey) {
      this.$router.push({ name: routeName, params: { [paramKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : Subelement {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }

  get navigationCollapsed () : boolean {
    return this.$store.getters.navigationCollapsed
  }

  get screenWidth () : number {
    return screen.width
  }
}
